import React, { Component } from 'react';
import Markdownkatexnew from "./Markdown.js";
import remarkGfm from 'remark-gfm';
// import MathRenderer from "../components/taskUser copy 3.js"
// import { HashLink } from 'react-router-hash-link';


import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import Select, { components } from 'react-select';
import { Modal } from "react-bootstrap";
import Navigation from "../screens/Navigation.jsx";
import Headroom from "react-headroom";
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, Toolbar } from 'ckeditor5';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import { registerLocale } from "react-datepicker";
import { parseISO } from "date-fns";
import wes from 'date-fns/locale/es';
import { IoMdCreate } from 'react-icons/io';
import { MdDelete, MdOutlineSupervisedUserCircle, MdRemove } from 'react-icons/md';
import { isAuth } from '../helpers/auth.js';
import { FaEdit } from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi';
registerLocale('es', wes);
timeago.register('es', es);

const techOptions = [
  { value: 'empresario', label: 'Empresario' },
  { value: 'egresado', label: 'Egresado' },
  { value: 'estudiantecole', label: 'Estudiante colegio' },
  { value: 'estudianteinst', label: 'Estudiante instituto' },
  { value: 'estudianteesfa', label: 'Estudiante ESFA' },
  { value: 'estudianteuni', label: 'Estudiante universitario' },
  { value: 'docenteuni', label: 'Docente Universitario' },
  { value: 'docenteesfa', label: 'Docente ESFA' },
  { value: 'apoderado', label: 'Apoderado' },
  // { value: 'analfabetos', label: 'Analfabetos' },
  // { value: 'libertes', label: 'Libertes' }
];

export default class Tests extends Component {
  handleChange = (selectedOption) => {
    this.setState({ subtipo: selectedOption.value });
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      items: [],
      stds: [],
      prgs: [],
      detail: "",
      subtipo: "",
      subtipostats: "",
      nsurveys: 0,
      id: "",
      ip: [],
      source: [],
      showModal: false,
      isLoading: false,
      submit: "",
      nice: `# Estudio de Mercado de ${process.env.REACT_APP_institute}

## 1. Resumen Ejecutivo
Este estudio de mercado tiene como objetivo analizar la viabilidad y demanda de una nueva universidad en Ayacucho, identificando oportunidades, competencia y preferencias de los potenciales estudiantes.

## 2. Análisis del Entorno
### 2.1. Contexto Socioeconómico
- Población total en la región: 555 555
- Edad promedio de la población: [17 25]
- Tasa de alfabetización: [52%]
- Nivel de ingreso promedio: [Valor]

### 2.2. Mercado Educativo
- Número de instituciones educativas superiores existentes: [Cantidad]
- Tipos de instituciones: públicas, privadas, técnicas
- Tasa de matriculación en educación superior: [Porcentaje]

## 3. Análisis de la Demanda
### 3.1. Perfil del Estudiante Potencial
- Edad: 17-25 años
- Intereses académicos: [Carreras o áreas de interés]
- Motivaciones: empleo, desarrollo profesional, interés académico

### 3.2. Tamaño del Mercado
- Estimación de estudiantes potenciales en la región: [Número]
- Tasa de interés en estudiar en la región: [Porcentaje]
- Proyección de crecimiento de estudiantes en los próximos 5 años: [Porcentaje]

## 4. Competencia


| Institución               | Tipo        | Oferta Académica             | Población Estimada | Fortalezas                           | Debilidades                          |
|---------------------------|-------------|------------------------------|---------------------|-------------------------------------|-------------------------------------|
| Universidad A             | Pública     | Ingeniería, Medicina, Derecho| [Número]           | Reputación, infraestructura         | Menor flexibilidad en horarios    |
| Universidad B             | Privada     | Negocios, Comunicación       | [Número]           | Personalización, servicios adicionales | Costos elevados                   |
| Instituto Técnico XYZ     | Técnica     | Tecnología, Administración   | [Número]           | Enfoque práctico, costos bajos      | Menor reconocimiento académico     |

## 5. Análisis FODA
### Fortalezas
- Ubicación estratégica
- Demanda insatisfecha en ciertas carreras
- Flexibilidad en modalidades de estudio

### Oportunidades
- Crecimiento de la población joven
- Alianzas con empresas locales
- Programas de becas y financiamiento

### Debilidades
- Alta competencia
- Necesidad de inversión en infraestructura
- Reconocimiento de marca aún en desarrollo

### Amenazas
- Cambios en políticas educativas
- Crisis económica afectando la matrícula
- Competidores ya establecidos con mayor reconocimiento

## 6. Estrategias de Mercado
- Diferenciación en programas académicos innovadores
- Estrategias de marketing digital y presencia en redes sociales
- Programas de becas y financiamiento
- Alianzas con empresas y organizaciones locales

## 7. Conclusiones
El mercado muestra una demanda significativa y oportunidad para una universidad que ofrezca programas innovadores, flexibilidad y enfoque en las necesidades del mercado laboral. Es recomendable realizar un plan de inversión detallado y estrategias de diferenciación para posicionarse efectivamente en el mercado.

## 8. Recomendaciones
- Realizar encuestas y focus groups para entender mejor las preferencias de los estudiantes potenciales.
- Analizar la viabilidad económica y financiamiento.
- Desarrollar alianzas estratégicas para potenciar la oferta académica.
- Implementar campañas de marketing dirigidas a jóvenes y padres de familia.

---

**Nota:** Datos específicos deben ser recolectados mediante encuestas, entrevistas y análisis de fuentes oficiales para mayor precisión.
`,
    }
  };

  open = () => this.setState({ showModal: true });
  close = () => this.setState({ showModal: false });


  updateSurveysId = async () => {
    console.log(this.state.id);

    await axios.put(
      `${process.env.REACT_APP_API_URL}/surveys/${this.state.id}`, { items: this.state.items }
    ).then(res => {
      // this.setState({
      //   theme: res.data[0],
      // });
      toast.info(res.data);
      // console.log(this.state.theme.task, this.state.theme.note);
    });
  }

  submitTest = async (tipo, ittems) => {
    this.setState({
      isLoading: true
    })

    const Data = {
      user: isAuth()._id,
      ip: this.state.ip,
      items: ittems,
      tipo: tipo,
      subtipo: this.state.subtipo
    };
    await axios.post(`${process.env.REACT_APP_API_URL}/surveys`, Data)
      .then(res => {
        console.log(res.data, "itemswww")
        toast.info(res)
        this.getSurveysSource()
        this.setState({
          isLoading: false
        })
        toast.dark(res.data)
      });
  };

  async componentDidMount() {
    // fetch('https://ipapi.co/json/')
    //   .then((res) => res.json())
    //   .then((data) => {
    //     console.log(data, "wwwwwwww")
    //     this.setState({
    //       ip: data,
    //     });
    //   })
    //   .catch((err) => console.error("Error fetching IP location:", err))
    this.getSurveysSource()
  }

  getSurveysSource = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/surveys/${'source'}`)
      .then(res => {
        console.log(res.data, "itemswww");
        // if (res.data.length > 0) {
        this.setState({
          source: res.data,
          // id: res.data[0]._id
        })
        // } else { this.setState({ items: [] }) }
      });
  }

  getSurveysSourceSubtipo = async (subtipo) => {
    // if (response) {

    if (isAuth()) {
      await axios.get(
        `${process.env.REACT_APP_API_URL}/surveys/www/${subtipo}`)
        .then(res => {
          if (res.data.length > 0) {
            console.log(res.data[0].subtipo, "itemswww");
            this.setState({
              items: res.data[0].items,
              subtipo: res.data[0].subtipo
            })
          } else { this.setState({ items: [] }) }
        });
    } else {
      const response = window.confirm('Deseas realizar hacer la encuesta de manera anónima?');
      if (response) {
        await axios.get(
          `${process.env.REACT_APP_API_URL}/surveys/www/${subtipo}`)
          .then(res => {
            if (res.data.length > 0) {
              console.log(res.data[0].subtipo, "itemswww");
              this.setState({
                items: res.data[0].items,
                subtipo: res.data[0].subtipo
              })
            } else { this.setState({ items: [] }) }
          });
      } else { this.props.history.push('/login') }
    }
  }

  getSurveysStatsSubtipo = async (subtipo) => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/surveys/newwww/${subtipo}`)
      .then(res => {
        console.log(res.data, "itemswww");
        if (res.data.note.length > 0) {

          var encuestas = res.data.note
          var source = res.data.notesource
          var prgs = []
          var stds = []

          for (var j = 0; j < source[0].items.length; j++) {
            prgs.push(source[0].items[j])
          }

          for (var j = 0; j < encuestas.length; j++) {
            stds.push([encuestas[j].name, encuestas[j].createdAt, encuestas[j].updatedAt])
          }

          var item = []
          for (var i = 0; i < encuestas.length; i++) {
            // console.log(encuestas[i].items)
            for (var j = 0; j < encuestas[i].items.length; j++) {
              if (encuestas[i].items[j].alt) {
                var wwwstd = encuestas[i].items[j].std
                var www = encuestas[i].items[j].alt
                var indexof = www.findIndex(subArray => subArray.some(text => text.includes(wwwstd)))
                // console.log(prgs[j])
                prgs[j].alt[indexof].push(indexof)
              } else {
                console.log(encuestas[i].items[j])
                prgs[j].obs.push(encuestas[i].items[j].std)
              }
            }
          }
        }
        console.log(stds, prgs)
        this.setState({ prgs: prgs, stds: stds, subtipostats: subtipo });
        if (encuestas) { this.setState({ nsurveys: encuestas.length }) }
        // this.props.history.push('/stats#wwwww')

      });
  }


  getNotes = async (tipo) => {
    console.log(tipo);
    await axios.get(
      `${process.env.REACT_APP_API_URL}/surveys/${tipo}`)
      .then(res => {
        console.log(res.data, "itemswww");
        if (res.data.length > 0) {
          this.setState({
            items: res.data[0].items,
            id: res.data[0]._id
          })
        } else { this.setState({ items: [] }) }
      });
  }


  onChangeItem = (text) => (e) => {
    // console.log(e.label[0], text);
    var www = this.state.items
    www[text].std = e.label[0]
    this.setState({
      items: www
    })

    this.updatesurveyStd(www)
  }


  onChangeText = (text, i) => {
    // console.log(text, i);
    var www = this.state.items
    www[i].std = text
    this.setState({
      items: www
    })
    console.log(www)
    this.updatesurveyStd(www)
  }

  updatesurveyStd = (data) => {
    if (!this.state.id) {
      const Data = {
        user: isAuth()._id ? isAuth()._id : "6a382709c284038205961561",
        email: isAuth().email ? isAuth().email : "anónimo",
        name: isAuth().name ? isAuth().name : "anónimo",
        ip: this.state.ip,
        items: data,
        tipo: "std",
        subtipo: this.state.subtipo
      }

      axios.post(
        `${process.env.REACT_APP_API_URL}/surveys/savesurvey`, Data
      ).then(www => {
        console.log(www.data._id)
        this.setState({
          items: www.data.items,
          subtipo: www.data.subtipo,
          id: www.data._id
        })
        this.getNotes(www.data._id)// this.setState({
        toast.success('Ok encuesta guardado')
      });
    } else {
      axios.put(
        `${process.env.REACT_APP_API_URL}/surveys/${this.state.id}`, { items: this.state.items }

      ).then(www => {
        toast.success(www.data)
        this.getNotes(this.state.id)// this.setState({
        //   items: www.data[0].items,
        //   subtipo: www.data[0].subtipo,
        //   id: www.data[0]._id
        // })
      });
    }
  }

  MarkdownOption = (props) => {
    // console.log(props.data.label[0])
    return (
      <components.Option {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.Option>
    );
  };

  MarkdownSingleValue = (props) => {
    // console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.SingleValue>
    );
  };

  RemoveSurvey = async (id) => {
    const response = window.confirm('Deseas eliminar este item?');
    if (response) {
      await axios.delete(`${process.env.REACT_APP_API_URL}/surveys/` + id);
      this.getSurveysSource()
      toast.dark('Removido correctamente');
    }
  };
  ///////////////////////////////////////////////////////////////////////////////////////////////


  render() {
    const { selectedOption } = this.state;

    return (
      <>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
        <Headroom>
          <Navigation />
        </Headroom>

        <div className={`container p-1 my-3 rounded`}>

          <a className="btn btn-link text-center w-100 ffont" style={{ fontSize: '34px' }} data-toggle="collapse" href="#myLinkContent" role="button" aria-expanded="false" aria-controls="myLinkContent">
            Estudio de mercado de la {process.env.REACT_APP_institute}
          </a>

          <div className="collapse" id="myLinkContent">
            <div className='text-center w-100'>
              <div className="text-center w-100 ffont" style={{ fontSize: '2em' }}>
                Resultados
              </div>
              <button className="btn btn-outline-info" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("estudiantecole"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Estudiantes de colegio
              </button>
              <button className="btn btn-outline-info" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("estudianteesfa"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Estudiantes ESFA
              </button>
              <button className="btn btn-outline-info" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("estudianteuni"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Estudiantes universitarios
              </button>
              <button className="btn btn-outline-success" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("egresado"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Egresados ESFA
              </button>

              <button className="btn btn-outline-primary" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("empresario"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Empresarios
              </button>
              <button className="btn btn-outline-danger" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("docenteuni"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Docentes universitarios
              </button>
              <button className="btn btn-outline-danger" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("docenteesfa"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Docentes ESFA
              </button>
              <button className="btn btn-outline-warning" style={{ margin: '.1em' }} onClick={() => { this.getSurveysStatsSubtipo("apoderado"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Apoderados
              </button>
            </div>

            <div className="text-center text-info w-100 my-1 ffont" style={{ fontSize: '2em' }}>
              {this.state.subtipostats ? `Seleccionaste ${this.state.subtipostats}` : ''}
            </div>

            <div id="wwwww" className='row justify-content-center align-items-center' style={{ margin: '.5em', minHeight: '50px' }}>
              {this.state.prgs ? this.state.prgs.map((number, i) =>
                <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12'}`}>
                  {i + 1}
                  <Markdownkatexnew className='marginbottomp'>
                    {number.prg}
                  </Markdownkatexnew>
                  <div className='justify-content-left align-items-center' style={{ margin: '.5em' }}>
                    {number.alt ? number.alt.map((numberr, j) =>
                      <div key={`${i + 1}${j}`} className="border rounded p-1 my-1 text-secondary">
                        {numberr[0]} {numberr.length - 1}({Math.round((numberr.length - 1) / this.state.nsurveys * 100 * 100) / 100 + '%'})
                        <div className='bg-warning py-1' style={{ width: Math.round((numberr.length - 1) / this.state.nsurveys * 100 * 100) / 100 + '%' }}>
                        </div>
                      </div>
                    ) : ''}
                    {number.obs ? number.obs.map((numberr, j) =>
                      <div key={`${i + 1}${j}`} className="my-1 border rounded p-1 text-secondary">
                        <Markdownkatexnew className='marginbottomp'>
                          {numberr}
                        </Markdownkatexnew>
                      </div>
                    ) : ''}
                  </div>
                </div>
              ) : ''}

              {/* {this.state.nsurveys > 0 ? <div className='text-info'>Total encuestados {this.state.nsurveys}</div> : ''} */}
            </div>

            {isAuth().rol === '1' && this.state.stds ? this.state.stds.map((number, i) =>
              <div key={i + 1}>
                {i + 1}. {number[0] ? number[0] : ''} <span style={{ fontSize: ".5em" }}><TimeAgo datetime={number[1] ? number[1] : ''} locale='es' /> {number[1] && number[2] ? Math.round((new Date(parseISO(number[2]).toString()) - new Date(parseISO(number[1]).toString())) / (1000 * 60) * 100) / 100 : ''} mnts {parseISO(number[1]).toString()}</span>
              </div>
            ) : ''}

            <div className="p-3 bg-light">
              <Markdownkatexnew remarkPlugins={[remarkGfm]}>
                {this.state.nice}
              </Markdownkatexnew>
            </div>
          </div>

          {isAuth().rol != '1' ? <div>
            <div className='text-center w-100'>
              <button className="btn btn-info" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("estudiantecole"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Estudiante de colegio
              </button>
              <button className="btn btn-info" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("estudianteesfa"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Estudiante de ESFA
              </button>
              <button className="btn btn-info" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("estudianteuni"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Estudiante universitario
              </button>
              <button className="btn btn-success" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("egresado"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Egresado de la ESFAFGPA
              </button>

              <button className="btn btn-primary" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("empresario"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Empresario
              </button>
              <button className="btn btn-danger" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("docenteuni"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Docente universitario
              </button>
              <button className="btn btn-danger" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("docenteesfa"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Docente ESFA
              </button>
              <button className="btn btn-warning" style={{ margin: '.1em' }} onClick={() => { this.getSurveysSourceSubtipo("apoderado"); this.setState({ option: "2", title: 'new', items: '', id: '' }) }}>
                Apoderado
              </button>
            </div>
          </div> : ''}




          <div className="text-uppercase text-center w-100 my-1">
            {this.state.subtipo ? `Seleccionaste ${this.state.subtipo}` : ''}
          </div>

          <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
            {this.state.items ? this.state.items.map((number, i) =>
              <div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
                <div className={`p-1 bg-light rounded border ${this.state.subtipo === 'egresado' ? 'border-success' : this.state.subtipo === 'empresario' ? 'border-primary' : this.state.subtipo === 'docenteuni' || this.state.subtipo === 'docenteesfa' ? 'border-danger' : this.state.subtipo === 'apoderado' ? 'border-warning' : 'border-info'}`}>
                  {/* {number.prg} */}
                  [{i + 1}]
                  <Markdownkatexnew>
                    {number.prg}
                  </Markdownkatexnew>
                  <Markdownkatexnew className="text-info">
                    {number.std}
                  </Markdownkatexnew>
                  {number.alt ?
                    <div className='marginbottomp'>
                      <Select placeholder="Seleccione opción" defaultValue={number.alt.filter(({ value }) => value === number.std)} onChange={this.onChangeItem(i)} options={
                        number.alt.map((guest, index) => {
                          return {
                            label: guest,
                            value: guest,
                            key: index
                          }
                        })
                      } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                    </div>
                    :
                    <CKEditor editor={ClassicEditor} config={{
                      language: 'es', placeholder: "Descripción",
                      toolbar: ["math", "|", "undo", "redo", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"]
                    }} data={number.std}
                      onBlur={(event, editor) => {
                        this.onChangeText(editor.getData(), i)
                      }} onReady={editor => {
                        // console.log('Editor is ready to use!', editor)
                      }}
                    // name="detail"
                    />
                  }
                </div>
                {/* {this.state.detail} */}
              </div>
            ) : ''}
          </div>
          <button className="btn btn-info  w-100" style={{ margin: '.1em', display: this.state.items.length > 0 ? '' : 'none' }} onClick={() => { this.setState({ subtipo: "", title: 'new', items: '', id: '' }) }}>
            Enviar
          </button>

          {isAuth().rol === '1' ?
            <>

              <div style={{ display: this.state.id ? '' : 'none' }}>
                <textarea className="form-control" value={JSON.stringify(this.state.items)} rows={8} onChange={(event) => { this.setState({ items: JSON.parse(event.target.value) }) }} required="required"> </textarea>
                <button type="button" className="btn btn-info w-100" onClick={() => { this.updateSurveysId() }} disabled={this.state.isLoading}>
                  Actualizar
                </button>
              </div>


              <div >
                <label htmlFor="wwwww" className="form-label mt-3">Tipo</label>
                <Select className="" defaultValue={techOptions.filter(({ value }) => value === this.state.subtipo)} onChange={this.handleChange} options={techOptions} placeholder="Seleccione item" />

                <button type="button" className="btn btn-primary my-1 w-100" onClick={() => {
                  this.submitTest('source', [
                    {
                      "prg": "¿Está satisfecho con nuestro servicio de atención al cliente?",
                      "alt": [
                        ["Si"],
                        ["No"],
                      ],
                      "std": ""
                    },
                    {
                      "prg": "¿Con qué frecuencia utiliza plataformas de streaming para ver películas?",
                      "alt": [
                        ["Todos los días"],
                        ["Varias veces por semana"],
                        ["Una vez por semana"],
                        ["Rara vez"],
                        ["Nunca"]
                      ],
                      "std": ""
                    },
                    {
                      "prg": "¿Qué es lo que más te gusta de tu nuevo trabajo?",
                      "obs": [],
                      "std": ""
                    }])
                }} disabled={this.state.isLoading}>
                  Registrar encuesta fuente {this.state.subtipo}
                </button>
              </div>

              <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
                {this.state.source ? this.state.source.map((number, i) =>
                  <div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
                    <div className="p-1 bg-light text-center rounded">
                      {number.tipo} ({number.subtipo})
                      <button className="btn" onClick={() => { this.getNotes(number._id) }}>
                        <BiEditAlt style={{ color: '#2ea09cff', fontSize: '34px' }} />
                      </button>
                      <button className="btn" onClick={() => { this.RemoveSurvey(number._id) }}>
                        <MdRemove style={{ color: '#a02e3dff', fontSize: '34px' }} />
                      </button>
                    </div>
                  </div>
                ) : ''}
              </div>

            </> : ''}





        </div>
      </>
    );
  }
}
